<template>
    <section class="slice slice-quotation">
        <div class="slice-content">
            <div class="slice-quotation__image">
                <CardHand>
                    <PrismicImage :image="slice.primary.image" />
                </CardHand>
            </div>
            <div class="slice-quotation__content">
                <PrismicRichText :field="slice.primary.quotation" />
                <div class="slice-quotation__author">{{ slice.primary.author }}</div>
                <div class="slice-quotation__author-title">{{ slice.primary.authorTitle }}</div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {QuotationSlice} from '@prismicio-types';
    import CardHand from '~/components/CardHand.vue';
    import PrismicImage from '~/components/PrismicImage.vue';

    defineProps(getSliceComponentProps<QuotationSlice>(['slice', 'index', 'slices', 'context']));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-quotation {
        .slice-content {
            max-width: 1024px;
            @include mq.screen_md(min) {
                display: flex;
                align-items: center;
                gap: var(--joy-core-spacing-10);
            }
        }
        &__image {
            flex: none;
            @include mq.screen_md(min) {
                text-align: right;
                width: 350px;
            }
        }
        &__content {
            @include mq.screen_md(min) {
                text-align: left;
                padding-bottom: var(--joy-core-spacing-8);
            }
        }
        &__author {
            margin-top: var(--joy-core-spacing-4);
            font-weight: var(--joy-font-weight-bold);
            text-transform: uppercase;

            &-title {
                margin-top: var(--joy-core-spacing-1);
                color: var(--joy-color-neutral-40);
            }
        }
    }
</style>
